jQuery(function($) {
    var index = 0;
    var correctAnswers = 0;
    var amountOfQuestions = $('.question-container').length;
    $('.answer-container').on('click', '.answers', function (e) {
        var $correctAnswerSelector = $(this).parent().find($('.correct-answer'));
        index++;
        questionToggle(index);
        // e.target.id is a string, data attribute is int.
        // Need to parseInt for strict type comparison.
        if(parseInt(e.target.id) === $correctAnswerSelector.data("answer")) {
            correctAnswers++;
        }
        if(index === amountOfQuestions) {
            if(correctAnswers === amountOfQuestions) {
                $('.completed-quiz-container').toggleClass('show');
            } else {
                $('.incomplete-quiz-container').toggleClass('show');
            }
        }
    });

    $('.restart-quiz').on('click', function(e) {
        location.reload();
    })
});

/**
 * Hide current question, show next.
 * @param {number} index - which has been incremented before every call to toggle correctly
 */
function questionToggle(index) {
    var currentQuestion = $('.single-quiz-container').find('.show');
    currentQuestion.toggleClass('show');
    $('#question-id-' + index).toggleClass('show');
}


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/scripts/pages/single-quiz.js
// module id = 32
// module chunks = 0